import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean {
    const userData = this.auth.currentUserDataValue;
    if (userData) {
      return true;
    }
    this.auth.logout();
    this.router.navigate(['/login']);
    return false;
  }
}
